import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Error404Component } from './error404/error404.component';
import { AtpAnonimusGuard } from './atp-core/guards/atp-anonimus.guard';
import { AtpAuthGuard } from './atp-core/guards/atp-auth.guard';
import { AuthComponent } from './auth/auth.component';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { AtpMergeParamsAndQueryParamsResolver } from './atp-core/atp-core';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./index/index.module').then(m => m.IndexModule),
  },
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule),
    canActivate: [
      AtpAnonimusGuard
    ]
  },
  {
    path: 'lots',
    loadChildren: () => import('./lots/lots.module').then(m => m.LotsModule),
  },
  {
    path: 'handbooks',
    loadChildren: () => import('./handbooks/handbooks.module').then(m => m.HandbooksModule),
    canActivate: [
      AtpAuthGuard
    ]
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
    canActivate: [
      AtpAuthGuard
    ]
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
    canActivate: [
      AtpAuthGuard
    ]
  },
  {
    path: 'subscriptionsectionproducts',
    loadChildren: () => import('./subscription-section-products/subscription-section-products.module').then(m => m.SubscriptionSectionProductsModule),
    canActivate: [
      AtpAuthGuard
    ]
  },
  {
    path: 'messages',
    loadChildren: () => import('./messages/messages.module').then(m => m.MessagesModule),
    canActivate: [
      AtpAuthGuard
    ]
  },
  {
    path: 'instruction',
    loadChildren: () => import('./instruction/instruction.module').then(m => m.InstructionModule),
    // canActivate: [
    //   AtpAuthGuard
    // ]
  },
  {
    path: 'agreement',
    loadChildren: () => import('./agreement/agreement.module').then(m => m.AgreementModule),
  },
  {
    path: 'policy',
    loadChildren: () => import('./policy/policy.module').then(m => m.PolicyModule),
  },
  {
    path: 'auth',
    component: AuthComponent,
    canActivate: [
      AtpAnonimusGuard
    ]
  },
  {
    path: 'passwordrecovery',
    component: PasswordRecoveryComponent,
    resolve: { resolver: AtpMergeParamsAndQueryParamsResolver },
    runGuardsAndResolvers: 'always',
    canActivate: [
      AtpAnonimusGuard
    ]
  },
  {
    path: 'accreditation',
    loadChildren: () => import('./accreditation/accreditation.module').then(m => m.AccreditationModule),
    canActivate: [
      AtpAuthGuard
    ]
  },
  {
    path: '**',
    component: Error404Component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
